import { createApi } from '@reduxjs/toolkit/query/react';
import { apiBaseQuery } from 'src/services/apiClient';

export const AUTHENTICATION_API_REDUCER_PATH = 'AuthenticationApi';

// Define a service using a base URL and expected endpoints
export const authenticationApi = createApi({
    reducerPath: AUTHENTICATION_API_REDUCER_PATH,
    baseQuery: apiBaseQuery(),
    endpoints: builder => ({
        saveOrUpdateClientSecret: builder.mutation({
            query: ({ scheme, payload }) => ({
                url: `/LoginProviders/${scheme}/ClientSecret`,
                method: 'POST',
                data: payload,
            }),
        }),
        deleteClientSecret: builder.mutation({
            query: ({ scheme }) => {
                return {
                    url: `/LoginProviders/${scheme}/ClientSecret`,
                    method: 'DELETE',
                };
            },
        }),
    }),
});

export const { useSaveOrUpdateClientSecretMutation, useDeleteClientSecretMutation } = authenticationApi;
